import { analytics } from './firebase'
import { logEvent } from 'firebase/analytics'

// Analytics event tracking utility
export const trackEvent = (eventName, parameters = {}) => {
  if (analytics && typeof window !== 'undefined') {
    try {
      logEvent(analytics, eventName, {
        timestamp: new Date().toISOString(),
        page_url: window.location.href,
        page_title: document.title,
        ...parameters
      })
    } catch (error) {
      console.warn('Analytics tracking failed:', error)
    }
  }
}

// Predefined tracking functions for common events
export const trackPageView = (pageName) => {
  trackEvent('page_view', {
    page_name: pageName,
    page_location: window.location.href
  })
}

export const trackContactFormSubmission = (formType = 'contact') => {
  trackEvent('form_submission', {
    form_type: formType,
    form_location: window.location.pathname
  })
}

export const trackServiceInterest = (serviceName) => {
  trackEvent('service_interest', {
    service_name: serviceName,
    source_page: window.location.pathname
  })
}

export const trackConsultationRequest = (source = 'unknown') => {
  trackEvent('consultation_request', {
    source: source,
    page_location: window.location.pathname
  })
}

export const trackDownload = (fileName, fileType) => {
  trackEvent('file_download', {
    file_name: fileName,
    file_type: fileType,
    download_location: window.location.pathname
  })
}

export const trackNavigation = (destination, source = 'nav') => {
  trackEvent('navigation', {
    destination: destination,
    source: source,
    from_page: window.location.pathname
  })
}

export const trackSearch = (searchTerm, resultsCount = 0) => {
  trackEvent('search', {
    search_term: searchTerm,
    results_count: resultsCount,
    search_location: window.location.pathname
  })
}

export const trackEngagement = (engagementType, details = {}) => {
  trackEvent('engagement', {
    engagement_type: engagementType,
    ...details
  })
}

// Enhanced ecommerce tracking for consultation bookings
export const trackConsultationBooking = (consultationType, value = 0) => {
  trackEvent('purchase', {
    currency: 'USD',
    value: value,
    items: [{
      item_id: `consultation_${consultationType}`,
      item_name: `${consultationType} Consultation`,
      item_category: 'Consultation',
      quantity: 1,
      price: value
    }]
  })
}

export default {
  trackEvent,
  trackPageView,
  trackContactFormSubmission,
  trackServiceInterest,
  trackConsultationRequest,
  trackDownload,
  trackNavigation,
  trackSearch,
  trackEngagement,
  trackConsultationBooking
}
